<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

const images = import.meta.glob('@/assets/testimonial-faces/*.jpg', { eager: true });

const avatarMap = Object.fromEntries(
    Object.entries(images).map(([path, module]) => {
      const fileName = path.split('/').pop().replace('.jpg', '').replace(/-/g, ' ');
      return [fileName, module.default];
    })
);

const testimonials = [
  'John S',
  'Anna L',
  'Mark T',
  'Sophia K',
  'Carlos M',
  'Emma R',
  'Tom B',
  'Nina D',
  'Alex P',
  'Sarah G',
  'James W',
  'Lisa F',
  'David H',
  'Julia C',
  'Michael E',
  'Bella S',
  'Oliver J',
  'Eva N',
  'Lucas M',
  'Chloe A'
];


const getAvatar = (name) => avatarMap[name] || '';

</script>
<template>
  <div class="w-full h-full relative">
    <Swiper
        :modules="[Navigation, Pagination, Autoplay]"
        :slidesPerView="1"
        :spaceBetween="20"
        :breakpoints="{ 768: { slidesPerView: 2 } }"
        :navigation="true"
        :pagination="{ clickable: true, dynamicBullets: true }"
        :autoplay="{
        delay: 4000,
        disableOnInteraction: false
      }"
        class="w-full h-full pb-10"
    >
      <SwiperSlide v-for="testimonial in testimonials" :key="testimonial" class="h-full flex">
        <div class="bg-white rounded-2xl p-6 shadow-md max-w-md mx-auto text-left h-full flex flex-col">

          <!-- Rating -->
          <div>
            <div class="flex items-center gap-1 text-blue-600 font-bold responsive-body-large">
              <span class="mt-1">5</span>
              <img src="@/assets/images/star_16x16.svg" alt="Star" class=" align-middle">
            </div>

            <!-- Content -->
            <p class="responsive-body-small mt-2">
              "{{ $t(`testimonials.${testimonial}.content`) }}"
            </p>
          </div>
          
          <div class="mt-auto flex items-center gap-3">
            <!-- Avatar -->
            <img
                :src="getAvatar(testimonial)"
                alt="User Avatar"
                class="w-10 h-10 rounded-full object-cover"
            />

            <!-- Name & Country -->
            <div>
              <div class="responsive-body-small font-semibold">
                {{ $t(`testimonials.${testimonial}.name`) }}
              </div>
              <div class="responsive-body-small">
                {{ $t(`testimonials.${testimonial}.country`) }}
              </div>
            </div>
          </div>

        </div>
      </SwiperSlide>


      

    </Swiper>
  </div>
</template>

<style scoped>

:deep(.swiper-pagination) {
  left: 5% !important;
}

:deep(.swiper-pagination-bullet) {
  background: white !important;
  opacity: 0.4 !important;
  width: 10px;
  height: 10px;
  transition: opacity 0.3s ease-in-out;
}


:deep(.swiper-pagination-bullet-active) {
  opacity: 1 !important;
  background: white !important;
}

:deep(.swiper-button-prev),
:deep(.swiper-button-next) {
  display: none;
}
:deep(.swiper-pagination-bullets-dynamic)
{
  transform: scale(0);
}
</style>